import { roundToSecondDecimal } from 'src/shared/utils/math';

type StopColorsProps = {
  colors: string[];
};

const DEFAULT_STOP_COLOR_VALUE = 0.5;

const StopColors = ({ colors = [] }: StopColorsProps) => {
  let offset: number = 0;
  const percentageOffset: number = roundToSecondDecimal(
    colors.length !== 0 ? 1 / colors.length : DEFAULT_STOP_COLOR_VALUE
  );
  return (
    <>
      {colors.map(color => {
        offset += percentageOffset;
        return <stop key={`${offset}-${color}`} offset={offset} stopColor={color} />;
      })}
    </>
  );
};

export default StopColors;
